import { useEffect } from 'react';

interface PageMetaProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogUrl?: string;
  ogImage?: string;
}

export default function PageMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogType = 'website',
  ogUrl,
  ogImage,
}: PageMetaProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);
    if (canonicalUrl) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonicalUrl);
    }
    if (ogTitle) setMeta('og:title', ogTitle, true);
    if (ogDescription) setMeta('og:description', ogDescription, true);
    if (ogType) setMeta('og:type', ogType, true);
    if (ogUrl) setMeta('og:url', ogUrl, true);
    if (ogImage) setMeta('og:image', ogImage, true);
    setMeta('twitter:card', 'summary_large_image');
    if (ogTitle) setMeta('twitter:title', ogTitle);
    if (ogDescription) setMeta('twitter:description', ogDescription);
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogType, ogUrl, ogImage]);

  return null;
}